module.exports = __webpack_public_path__ + "static/profile-pic-0671be320bf55395dd09847590d4db3b.jpg";